import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class CheckTemplateRollsProfileResData extends ApiGenericResponse {
    allowedInstallations: string[];
    notAllowedInstallations: string[];

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.AllowedInstallations) {
            this.allowedInstallations = new Array<string>();
            obj.AllowedInstallations.forEach((name) => {
                this.allowedInstallations.push(name);
            });
        }
        if (obj.NotAllowedInstallations) {
            this.notAllowedInstallations = new Array<string>();
            obj.NotAllowedInstallations.forEach((name) => {
                this.notAllowedInstallations.push(name);
            });
        }
    }
}
